import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../components/PageConfigProvider/constants';
import type { TabContent } from '../components/PageConfigProvider/page-reducer';
import {
  type Page,
  PageType,
  RevelioPageId,
} from '../components/PageConfigProvider/types';
import type { MetricValues } from '../components/PageConfigProvider/types/metric';
import { FilterId } from '../filters/types/filters';

const geographyPostingsMetrics: MetricValues[] = [
  'postings_active',
  'postings_new',
  'postings_removed',
];

const geographyPostingsItems: TabContent['items'] = [
  {
    position: { x: 0, width: 16, y: 0, height: 12 },
    id: 'geography-postings-posting-salary',
    title: 'Salary',
    info: {
      text: 'The average salary listed on job postings.',
    },
    plot: {
      defaultMetricOptions: ['posting_salary'],
      chartType: 'line',
    },
  },
  {
    position: { x: 16, width: 16, y: 0, height: 12 },
    id: 'geography-postings-time-to-fill',
    title: 'Time to Fill',
    info: {
      text: 'The average time it takes to fill a job posting.',
    },
    plot: {
      defaultMetricOptions: ['time_to_fill'],
      chartType: 'line',
    },
  },
  {
    position: { x: 0, width: 32, y: 12, height: 24 },
    id: 'geography-postings-postings-volume',
    title: 'Postings',
    info: {
      text: 'The number of active job postings, new job postings, and removed job postings.',
    },
    plot: {
      defaultMetricOptions: geographyPostingsMetrics,
      chartType: 'volume',
    },
  },
  {
    position: { x: 32, width: 16, y: 0, height: 36 },
    id: 'geography-postings-active-postings-companies',
    title: 'Top Companies',
    info: {
      text: 'The top 15 companies in terms of number of added postings over the selected time range.',
    },
    plot: {
      defaultMetricOptions: ['postings_active'],
      secondaryDimension: 'role',
      chartType: 'grouped-bar',
    },
  },
];

const geographyPostingsTab: TabContent = {
  id: 'geography-postings',
  items: geographyPostingsItems,
  grid: { rows: DEFAULT_GRID_ROWS, columns: DEFAULT_GRID_COLUMNS },
  primaryFilter: {
    id: FilterId.GEOGRAPHY,
    selectionLimit: 6,
    selectionDefault: 1,
    tagColors: true,
  },
  secondaryFilters: [
    FilterId.ROLE,
    FilterId.SENIORITY,
    FilterId.SKILL,
    FilterId.CUSTOM_SKILL,
    FilterId.COMPANY,
    FilterId.DATE_RANGE,
    FilterId.TITLE,
    FilterId.POSTINGS_SOURCE,
    FilterId.METRIC_MODE,
  ].map((id) => ({ id })),
};

export const geographyPostings: Page = {
  type: PageType.REVELIO_PUBLIC,
  id: RevelioPageId.GEOGRAPHY_POSTINGS,
  revelioPageId: RevelioPageId.GEOGRAPHY_POSTINGS,
  name: 'Job Postings',
  owner: { id: 'revelio-labs', username: 'revelio-labs' },
  tabs: [
    {
      id: 'geography-postings',
      label: 'Job Postings',
      tabContent: geographyPostingsTab,
      isActive: true,
    },
  ],
};
